
export default function CopyAssetTypeDialogController(
  $q,
  $rootScope,
  $scope,
  $timeout,
  ssDialogService,
  alerts,
  loaderService,
  riskDataService,
  assetDataService,
) {
  const vm = this;

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleCopyAssetTypeSubmit = _handleCopyAssetTypeSubmit;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    vm.customerAssetTypeId = vm.assetType.customerAssetTypeId;
    _initEventListeners();
  }

  function _initEventListeners() {
  }

  function _handleCloseDialogClick() {
    _closeDialog();
  }

  function _handleCopyAssetTypeSubmit() {
    if ($scope.copyAssetTypeForm.$valid) {
      loaderService.showViewLoader = true;

      return assetDataService.copyAssetType(vm.customerAssetTypeId, vm.name).then((response) => {
        loaderService.showViewLoader = false;
        if (!response.data) {
          alerts.error('An error occurred while copying the Asset Type.');
        } else {
          alerts.success('The Asset Type has been successfully copied.');
          $rootScope.$broadcast('refreshAssetTypes');
          _closeDialog();
        }
      });
    }
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.assetAdmin.copyAssetTypeDialog);
  }
}

CopyAssetTypeDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  '$timeout',
  'ssDialogService',
  'alerts',
  'loaderService',
  'riskDataService',
  'assetDataService',
];
